module.exports = __webpack_public_path__ + "media/images/boa-699b7980aed1507e4a3f402245e4016d.png";